import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  formControl: {
    minWidth: '94%',
    float: 'left',
  },
  titleSection: {
    marginBottom: '2%',
  },
  selectEmpty: {
    marginTop: 5,
  },
  fRight: {
    float: 'right',
  },
}));
